module.exports = __webpack_public_path__ + "img/ydx.a827d5fb.png";